import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material'

const GenerateTestCasesConfirmationModal = ({
  generateTestCasesForAllPagesOpen,
  setGenerateTestCasesForAllPagesOpen,
  handleGenerateTestCases,
  pagesToggler,
  setPagesToggler
}) => {

  const handleCloseDeleteDialog = () => {
    setGenerateTestCasesForAllPagesOpen(false)
  }

  const handleConfirm = async () => {
    try {
      handleGenerateTestCases([])
      setPagesToggler(!pagesToggler)
      setGenerateTestCasesForAllPagesOpen(false)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Dialog open={generateTestCasesForAllPagesOpen} onClose={handleCloseDeleteDialog}>
      <Box className="generateTestCasesModal">
        <DialogTitle className="generateTestCasesModalTitle">
          Confirm Generation
        </DialogTitle>
        <DialogContent className="generateTestCasesModalContent">
          <Typography variant='body1' mb={2}>
            Are you sure you want to generate test cases for all pages?
          </Typography>
        </DialogContent>
        <DialogActions className="generateTestCasesModalActions">
          <Button className="generateTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          <Button className="generateTestCasesModalButton" onClick={handleConfirm} color="secondary" variant="contained" autoFocus>
            CONFIRM
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default GenerateTestCasesConfirmationModal